import Vue from 'vue';
import Vuex from 'vuex';
import account from "./modules/account";
import auth from './modules/auth.js';
import balance_sheet from "./modules/balance_sheet";
import dashboard from "./modules/dashboard";
import income_statement from "./modules/income_statement";
import menu from './modules/menu.js';
import project from "./modules/project";
import recent_user_account from "./modules/recent_user_account";
import recent_user_transaction_category from "./modules/recent_user_transaction_category";
import transaction from "./modules/transaction";
import transaction_categories from "./modules/transaction_categories";

Vue.use(Vuex);

let defaultState = {
    modules: {
        auth,
        menu,
        account,
        project,
        transaction_categories,
        transaction,
        income_statement,
        dashboard,
        balance_sheet,
        recent_user_account,
        recent_user_transaction_category
    },
    state: {
        isLoading: false
    }
}

export default new Vuex.Store(defaultState);